import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Grid, MenuItem } from '@material-ui/core';
import { InputField, ButtonComponent, Toggle } from '../index.js';
import { useStyles } from './styles.js';

class Download extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onClick() {
    this.props.downloadOptions(this.state.option_type);
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid>
        <Grid container className={classes.gridContainer}>
          <Grid item md={2} xs={12}>
            {' '}
            <label>Available Options</label>
          </Grid>
          <Grid item md={2} xs={12}>
            <InputField
              select
              show_label={false}
              id="option_type"
              name="option_type"
              onChange={e => {
                this.setState({
                  option_type: e.target.value,
                });
                this.props.onDownloadOptionChange(e.target.value);
              }}
              value={this.state.option_type}
            >
              {this.props.gamesRelatedData.game_data_option.map(
                (value, index) => {
                  return (
                    <MenuItem
                      value={value._id}
                      key={`dataOptionDropDown${value._id}`}
                    >
                      {value.name}
                    </MenuItem>
                  );
                },
              )}
            </InputField>
          </Grid>
          <Grid item md={4} xs={12}>
            <ButtonComponent
              button_name={'Download Options'}
              className={classes.button}
              style={{}}
              onClick={this.onClick.bind(this)}
            />
          </Grid>
        </Grid>
        <br />
        <Grid container className={classes.gridContainer}>
          <Grid item md={2} xs={12}>
            {' '}
            <label>API integration</label>
          </Grid>
          <Grid item md={2} xs={12}>
            <Toggle
              name="api"
              checked={this.state.checked}
              handleChange={e => {
                this.setState({ checked: !this.state.checked });
              }}
            />
          </Grid>
          {this.state.checked && (
            <Grid item md={4} xs={12}>
              <ButtonComponent
                disabled={this.props.disabled}
                button_name={'Download API Options'}
                className={classes.button}
                style={{}}
                onClick={this.props.apiDownloadOptions}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }
}

Download.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(Download);
